import React from 'react';
import { Card, CardContent, Typography, Box, LinearProgress } from '@mui/material';

const ArticleCountCard = ({
  title,
  count,
  maxCount,
  valueFormatter,
  differenceFormatter,
  overFormatter,
}) => {
  const numericCount = Number.isFinite(Number(count)) ? Number(count) : 0;
  const numericMax = Number.isFinite(Number(maxCount)) ? Number(maxCount) : 0;
  const positiveCount = Math.max(numericCount, 0);
  const base = Math.max(positiveCount, numericMax, 1);
  const progressBarValue = (positiveCount / base) * 100;
  const maxProgressBarValue = numericMax > 0 ? (numericMax / base) * 100 : 0;
  const excessValue =
    numericMax > 0 && positiveCount > numericMax
      ? positiveCount - numericMax
      : 0;
  const excessPercent =
    numericMax > 0 && positiveCount > numericMax
      ? (excessValue / numericMax) * 100
      : 0;

  const defaultValueFormatter = (value) => `${value} articole`;
  const defaultDifferenceFormatter = (value) =>
    `Fetelor mai trebuie să aduceți: ${value} articole`;
  const defaultOverFormatter = (percent) => `${percent.toFixed(2)}% over`;

  const displayValue = (valueFormatter || defaultValueFormatter)(numericCount);
  const remainingValue =
    numericMax > 0 ? Math.max(numericMax - positiveCount, 0) : 0;
  const differenceText =
    numericMax > 0 && positiveCount < numericMax
      ? (differenceFormatter || defaultDifferenceFormatter)(remainingValue)
      : null;
  const overText =
    excessValue > 0
      ? (overFormatter || defaultOverFormatter)(excessPercent, excessValue)
      : null;

  return (
    <Card>
      <CardContent>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="body1">{displayValue}</Typography>
        {differenceText && (
          <Typography variant="body2">{differenceText}</Typography>
        )}
        <Box sx={{ width: '100%', mt: 2, position: 'relative' }}>
          <LinearProgress
            variant="determinate"
            value={progressBarValue}
            sx={{
              height: 10,
              bgcolor: 'lightgray',
              '& .MuiLinearProgress-bar': {
                bgcolor: count >= maxCount ? 'green' : 'tomato',
              },
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              left: `${Math.min(Math.max(maxProgressBarValue, 0), 100)}%`,
              top: 0,
              height: '100%',
              borderLeft: '2px solid black',
            }}
          />
          {overText && (
            <Typography
              variant="body2"
              sx={{
                position: 'absolute',
                left: `${Math.min(Math.max(maxProgressBarValue, 0), 100)}%`,
                top: -20,
                transform: 'translateX(-50%)',
                bgcolor: 'white',
                p: '2px 4px',
                borderRadius: '4px',
                boxShadow: 1,
              }}
            >
              {overText}
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ArticleCountCard;
